export const sideBar = () => {
  return {
    work_orders: 'Work Orders',
    invoices: 'Invoices',
    sites: 'Sites',
    company_profile: 'Company Profile',
    exit_masquerade: 'Exit Masquerade'
  }
}
